import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function VoterIDcardservice() {

  

  return (
    <>
      <Header/>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="text-white">Voter ID Card</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Voter Id card</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <section id="about" className="about section light-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  <b>Sai Financial Service</b> Provider acts as a facilitator for Voter ID card services and does not issue Voter ID cards. The final approval and issuance are governed by the Election Commission of India.
                </p>
                <h3>Services terms&conditions:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b> New Voter ID Application:</b> Assistance in applying for a new Voter ID card for first-time voters.</p></li>
                  <li><p className="fst-italic"><b>Correction and Update Service:</b> Help with correcting or updating personal details such as name, address, date of birth, or photo on your existing Voter ID card.</p></li>
                  <li><p className="fst-italic"><b>Service Fee Policy:</b>The ₹200 service charge is non-refundable, even if the application is rejected or delayed due to incomplete or inaccurate information provided by the applicant.</p></li>
                  <li><p className="fst-italic"><b>Government Fees:</b> Any applicable fees charged by the Election Commission of India or related authorities must be borne by the applicant.</p></li>
                  <li><p className="fst-italic"><b>Accuracy of Information:</b> The applicant is responsible for ensuring all details and documents provided are accurate and complete. Sai Financial Service Provider will not be liable for delays or rejections caused by errors or discrepancies in the provided information.</p></li>
                  <li><p className="fst-italic"><b>Documentation Responsibility:</b> The applicant must provide all required documents in the prescribed format and within the necessary timelines.</p></li>
                  
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                  <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                  <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                </ol>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets\images\svg\loans.jpg" alt className="h-100 p-2 img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <h1 style={{ textAlign: 'center' }}>
              <span>Voter Id card</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default VoterIDcardservice
